import { Stack } from "@mui/material";
import { Routes, Route } from "react-router-dom";
import { Suspense } from "react";
import PrivateRoute from "./auth/PrivateRoute";
import { useLangContext } from "./context/langContext";
import PanelLayout from "./pages/panel/PanelLayout";
import { accessPathsEnums, routerPaths } from "./constants/Paths";
import AuthLayout from "./pages/auth/AuthLayout";
import LoadingPage from "./Loading";
import TransferPage from "./pages/charge/transfer";
import LoginPage from "./pages/auth/login";
import NotFoundPage from "./pages/notFound";
import TicketDetailsPage from "./pages/panel/ticketDetailPage";
import TicketPage from "./pages/panel/ticketPage";
import DashboardPage from "./pages/panel/dashboardPage";
import FilesPage from "./pages/panel/filesPage";
import WalletPage from "./pages/panel/walletPage";
import ServersPage from "./pages/panel/serversPage";
import ServersDetailsPage from "./pages/panel/serverDetailsPage";
import UsersPage from "./pages/panel/usersPage";
import ReceiptsPage from "./pages/panel/receiptsPage";
import PaymentsPage from "./pages/panel/paymentsPage";
import WorkspacesPage from "./pages/panel/workspacesPage";
import WalletTransactionPage from "./pages/panel/walletTransactionPage";
import BroadCastingPage from "./pages/panel/broadCastingPage";
import BroadCastingDetailsPage from "./pages/panel/broadCastingDetailsPage";
import ReceiptsDetailPage from "./pages/panel/receiptDetailPage";
import RolesPage from "./pages/panel/rolesPage";
import AccessManagePage from "./pages/panel/accessManagePage";
import PartnersManagePage from "./pages/panel/partnersManagePage";
import PbxCallDetailPage from "./pages/panel/pbxCallDetailsPage";
import CallToNumberDetailPage from "./pages/panel/callToNumberDetailPage";
import AccessTokenPage from "./pages/panel/accessTokenPage";
import RoleAccessRoute from "./auth/roleAccessRoute";
import NotAccessPage from "./pages/notAccess";
import SecureCallsPage from "./pages/panel/secureCallsPage";
import LogsPage from "./pages/panel/logsPage";
import OTPCallsPage from "./pages/panel/otpCallsPage";
import ReportPage from "./pages/panel/reportPage";
import PartnerDetailsPage from "./pages/panel/PbxServerDetailsPage";
import BlockNumbersPage from "./pages/panel/blockNumbersPage";
import SendCallsPage from "./pages/panel/sendCallsPage";

function ProjectRouter() {
  const { dir } = useLangContext();
  return (
    <Stack dir={dir} width={"100%"} minHeight={"fit-content"}>
      <Suspense fallback={<LoadingPage />}>
        <Routes>
          <Route path="/">
            <Route element={<AuthLayout />}>
              <Route element={<LoginPage />} path={routerPaths.LOGIN} />
            </Route>
            <Route element={<PrivateRoute />}>
              <Route path="/">
                <Route element={<TransferPage />} path={routerPaths.TRANSFER} />
              </Route>
              <Route path="/" element={<PanelLayout />}>
                <Route index element={<DashboardPage />} />
                <Route
                  element={
                    <RoleAccessRoute aclSection={accessPathsEnums.files_list} />
                  }
                >
                  <Route element={<FilesPage />} path={routerPaths.MY_FILES} />
                </Route>

                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.tickets_list}
                    />
                  }
                >
                  <Route element={<TicketPage />} path={routerPaths.SUPPORT} />
                </Route>

                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.voice_broadcasts_list}
                    />
                  }
                >
                  <Route
                    element={<BroadCastingPage />}
                    path={routerPaths.VOICE_BROADCASTS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute aclSection={accessPathsEnums.users_list} />
                  }
                >
                  <Route element={<UsersPage />} path={routerPaths.USERS} />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.acl_roles_list}
                    />
                  }
                >
                  <Route element={<RolesPage />} path={routerPaths.ROLES} />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.acl_sections_list}
                    />
                  }
                >
                  <Route
                    element={<AccessManagePage />}
                    path={routerPaths.ACCESS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.payment_receipts_list}
                    />
                  }
                >
                  <Route
                    element={<ReceiptsPage />}
                    path={routerPaths.RECEIPTS}
                  />
                </Route>

                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.payment_receipts_list}
                    />
                  }
                >
                  <Route
                    element={<ReceiptsDetailPage />}
                    path={`${routerPaths.RECEIPT}/:id`}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.payment_gateway_list}
                    />
                  }
                >
                  <Route
                    element={<PaymentsPage />}
                    path={routerPaths.PAYMENTS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.voice_broadcast_numbers_list}
                    />
                  }
                >
                  <Route
                    element={<CallToNumberDetailPage />}
                    path={routerPaths.BROAD_NUMBER}
                  />
                </Route>

                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.pbx_call_detail_records_list}
                    />
                  }
                >
                  <Route
                    element={<PbxCallDetailPage />}
                    path={routerPaths.PBX_CALL_DETAIL}
                  />
                </Route>

                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.transactions_list}
                    />
                  }
                >
                  <Route
                    element={<WalletTransactionPage />}
                    path={routerPaths.WALLET_TRANSACTION}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.wallets_list}
                    />
                  }
                >
                  <Route element={<WalletPage />} path={routerPaths.WALLET} />
                </Route>

                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.partner_list}
                    />
                  }
                >
                  <Route
                    element={<PartnersManagePage />}
                    path={routerPaths.PARTNERS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.access_tokens_list}
                    />
                  }
                >
                  <Route
                    element={<AccessTokenPage />}
                    path={routerPaths.ACCESS_TOKEN}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.workspaces_list}
                    />
                  }
                >
                  <Route
                    element={<WorkspacesPage />}
                    path={routerPaths.WORKSPACES}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.pbx_servers_list}
                    />
                  }
                >
                  <Route
                    element={<ServersDetailsPage />}
                    path={`${routerPaths.SERVERS}/:id`}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.voice_broadcasts_list}
                    />
                  }
                >
                  <Route
                    element={<BroadCastingDetailsPage />}
                    path={`${routerPaths.VOICE_BROADCASTS}/:id`}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.tickets_details}
                    />
                  }
                >
                  <Route
                    element={<TicketDetailsPage />}
                    path={`${routerPaths.SUPPORT}/:id`}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.pbx_servers_list}
                    />
                  }
                >
                  <Route element={<ServersPage />} path={routerPaths.SERVERS} />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.pbx_servers_list}
                    />
                  }
                >
                  <Route element={<ServersPage />} path={routerPaths.TRUNKS} />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.secure_calls_list}
                    />
                  }
                >
                  <Route
                    element={<SecureCallsPage />}
                    path={routerPaths.SECURE_CALLS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute aclSection={accessPathsEnums.logs_list} />
                  }
                >
                  <Route element={<LogsPage />} path={routerPaths.LOGS} />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.otp_calls_list}
                    />
                  }
                >
                  <Route
                    element={<OTPCallsPage />}
                    path={routerPaths.OTP_CALLS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={
                        accessPathsEnums.partner_details ||
                        accessPathsEnums.reports_call_queue_sender
                      }
                    />
                  }
                >
                  <Route element={<ReportPage />} path={routerPaths.REPORT} />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.partner_reset_status}
                    />
                  }
                >
                  <Route
                    element={<PartnerDetailsPage />}
                    path={`${routerPaths.PARTNERS}/:id`}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.admin_block_numbers_list}
                    />
                  }
                >
                  <Route
                    element={<BlockNumbersPage />}
                    path={routerPaths.BLOCK_NUMBERS}
                  />
                </Route>
                <Route
                  element={
                    <RoleAccessRoute
                      aclSection={accessPathsEnums.admin_send_calls_list}
                    />
                  }
                >
                  <Route
                    element={<SendCallsPage />}
                    path={routerPaths.SEND_CALLS}
                  />
                </Route>
              </Route>
            </Route>
          </Route>
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/404" element={<NotFoundPage />} />
          <Route path="/403" element={<NotAccessPage />} />
        </Routes>
      </Suspense>
    </Stack>
  );
}

export default ProjectRouter;
